import { color, fontSize, height, styled, width } from "@mui/system";
import { Box, Menu } from "@mui/material";


export const SideBarStyles = styled(Box)(({theme}) => (

  
  {
  "& .sidebarItemTooltip": {
    backgroundColor: theme.palette.common.grey, 
    color: theme.palette.common.black, 
  },
  "& .drawerStyles":{
    width: 'fit-content',
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: 'fit-content',
      boxSizing: 'border-box',
      maxHeight: `calc(100vh - ${theme.navbar.navbarHeight}px)`,
      position: 'fixed',
      top: `${theme.navbar.navbarHeight}px`,
      left: 0,
      maxWidth: `${theme.sidebar.sidebarWidth}px`,
      overflowX: 'hidden',
              },
  },
  "& .departmentsIcon": {
    transform: 'scaleX(1.05) scaleY(0.91)',
  }
}));

export const MenuStyles = styled(Menu)(({theme}) => ({
  '& .overriderMenuPaper': {
    boxShadow: theme.shadows.main, // Example: Remove shadow
    borderRadius: theme.spacing(1), // Example: Change border-radius
    borderTopLeftRadius:0,
    borderBottomLeftRadius:0,
  },
}));
